export function isTabHidden(): boolean {
    return document.hidden;
}
